<template>
    <div class="container">
        <div class="customer">
            <div class="title">
                Customer Details
            </div>
            <div class="table">
                <div>
                    <label>First Name</label>
                    <input v-model="customer.firstName" @keyup="copyFirstName()" type="text" id="customerFirstname" v-on:keyup.enter="newFocus('customerSurname')">
                </div>
                <div>
                    <label>Surname</label>
                    <input v-model="customer.surName" @keyup="copySurame()" type="text" id="customerSurname" v-on:keyup.enter="newFocus('customerEmail')">
                </div>
                <div>
                    <label>Email</label>
                    <input v-model="customer.email" type="text" id="customerEmail" v-on:keyup.enter="newFocus('customerPhone')">
                </div>
                <div>
                    <label>Contact Number</label>
                    <input v-model="customer.phone" @keyup="copyNumber()" type="text" id="customerPhone" v-on:keyup.enter="newFocus('billingFirstName')">
                </div>
            </div>
        </div>
        <div class="billing-address">
            <div class="title">
                Billing Details
            </div>
            <div class="table">
                <div>   
                    <label>Contact First Name</label>
                    <input v-model="billingAddress.firstName" type="text" @keyup="billingFirstNameEdit = true;" id="billingFirstName" v-on:keyup.enter="newFocus('billingSurname')">
                </div>
                <div>
                    <label>Contact Surname</label>
                    <input v-model="billingAddress.surName" type="text" @keyup="billingSurnameEdit = true;" id="billingSurname" v-on:keyup.enter="newFocus('billingLine1')">
                </div>
                <div>
                    <label>Line 1</label>
                    <input v-model="billingAddress.line1" type="text" id="billingLine1" v-on:keyup.enter="newFocus('billingLine2')">
                </div>
                <div>
                    <label>Line 2</label>
                    <input v-model="billingAddress.line2" type="text" id="billingLine2" v-on:keyup.enter="newFocus('billingLine3')">
                </div>
                <div>
                    <label>Town</label>
                    <input v-model="billingAddress.town" type="text" id="billingLine3" v-on:keyup.enter="newFocus('billingLine4')">
                </div>
                <div>
                    <label>County</label>
                    <input v-model="billingAddress.county" type="text" id="billingLine4" v-on:keyup.enter="newFocus('billingPostcode')">
                </div>
                <div>
                    <label>Post Code</label>
                    <input v-model="billingAddress.postcode" type="text" id="billingPostcode" v-on:keyup.enter="newFocus('billingNumber')">
                </div>
                <div>
                    <label>Contact Number</label>
                    <input v-model="billingAddress.phone" type="text" id="billingNumber" v-on:keyup.enter="newFocus('deliveryFirstName')">
                </div>
                <div class="alternative-delivery-address">
                    <input type="checkbox" ref="alternativeDeliveryAddress" @change="alternativeDeliveryAddress()"> Use alternative delivery address
                </div>
            </div>
        </div>
        <div class="delivery-address" :class="{ show : showDeliveryAddress }">
            <div class="title">
                Delivery Details
            </div>
            <div class="table">
                <div>
                    <label>Contact First Name</label>
                    <input v-model="deliveryAddress.firstName" type="text" @keyup="deliveryFirstNameEdit = true;" id="deliveryFirstName" v-on:keyup.enter="newFocus('deliverySurname')">
                </div>
                <div>
                    <label>Contact First Name</label>
                    <input v-model="deliveryAddress.surName" type="text" @keyup="deliverySurnameEdit = true;" id="deliverySurname" v-on:keyup.enter="newFocus('deliveryLine1')">
                </div>
                <div>
                    <label>Line 1</label>
                    <input v-model="deliveryAddress.line1" type="text" id="deliveryLine1" v-on:keyup.enter="newFocus('deliveryLine2')">
                </div>
                <div>
                    <label>Line 2</label>
                    <input v-model="deliveryAddress.line2" type="text" id="deliveryLine2" v-on:keyup.enter="newFocus('deliveryLine3')">
                </div>
                <div>
                    <label>Town</label>
                    <input v-model="deliveryAddress.town" type="text" id="deliveryLine3" v-on:keyup.enter="newFocus('deliveryLine4')">
                </div>
                <div>
                    <label>County</label>
                    <input v-model="deliveryAddress.county" type="text" id="deliveryLine4" v-on:keyup.enter="newFocus('deliveryPostcode')">
                </div>
                <div>
                    <label>Post Code</label>
                    <input v-model="deliveryAddress.postcode" type="text" id="deliveryPostcode" v-on:keyup.enter="newFocus('deliveryNumber')">
                </div>
                <div>
                    <label>Contact Number</label>
                    <input v-model="deliveryAddress.phone" type="text" id="deliveryNumber" v-on:keyup.enter="newFocus('makePayment')">
                </div>
            </div>
        </div>
        <div class="check-out-button">
            <button @click="makePayment()" id="makePayment">Make payment</button>
        </div>
        <form method="POST" id="SagePayForm" action="">
            <input type="hidden" name="VPSProtocol" value= "3.0">
            <input type="hidden" name="TxType" value= "PAYMENT">
            <input type="hidden" name="Vendor" value= "johnsonfitness">
            <input type="hidden" name="Crypt" id="crypt">
        </form>
    </div>
</template>

<script>


export default {
    name : 'Checkout',
    props : {
        mainColour : String
    },
    data : function(){
        return {
            customer : {
                firstName : '',
                surName : '',
                email : '',
                phone : ''
            },
            deliveryAddress : {
                firstName: "",
                surName: "",
                line1: "",
                line2: "",
                town: "",
                county: "",
                postcode: "",
                phone: ""
            },
            billingAddress : {
                firstName: "",
                surName: "",
                line1: "",
                line2: "",
                town: "",
                county: "",
                postcode: "",
                phone: ""
            },
            showDeliveryAddress : false,
            billingFirstNameEdit : false,
            billingSurnameEdit : false,
            deliveryFirstNameEdit : false,
            deliverySurnameEdit : false,
            billingNumberEdit : false,
            deliveryNumberEdit : false
        }
    },
    methods : {
        newFocus : function(newFocus) {
            document.getElementById(newFocus).focus();
        },
        copyFirstName : function() {
            if( ! this.billingFirstNameEdit ){
                this.billingAddress.firstName = this.customer.firstName;
            }
            if( ! this.deliveryFirstNameEdit ){
                this.deliveryAddress.firstName = this.customer.firstName;
            }
        },
        copySurame : function() {
            if( ! this.billingSurnameEdit ){
                this.billingAddress.surName = this.customer.surName;
            }
            if( ! this.deliverySurnameEdit ){
                this.deliveryAddress.surName = this.customer.surName;
            }
        },
        copyNumber : function(){
            if( ! this.billingNumberEdit ){
                this.billingAddress.phone = this.customer.phone;
            }
            if( ! this.deliveryNumberEdit ){
                this.deliveryAddress.phone = this.customer.phone;
            }
        },
        checkOrder : function(){
            /**
             * Check that the customer details are filled in
             */

            var check = true;
            var requiredFields = [
                {value: this.customer.firstName, id: 'customerFirstname' },
                {value: this.customer.surName, id: 'customerSurname' },
                {value: this.customer.email, id: 'customerEmail' },
                {value: this.customer.phone, id: 'customerPhone' },
                {value: this.billingAddress.line1, id: 'billingLine1' },
                {value: this.billingAddress.town, id: 'billingLine3' },
                {value: this.billingAddress.postcode, id: 'billingPostcode' },
            ]

            requiredFields.forEach( function( field ) {
                document.getElementById( field.id ).style.border = "1px solid black"
                if( field.value == '' ){
                    check = false
                    document.getElementById( field.id ).style.border = "2px solid red"
                }
            } )

            if( ! check )
            {
                alert( 'Please enter values in all required boxes' )
            }

            return check
            
        },
        alternativeDeliveryAddress : function() {
            this.showDeliveryAddress = this.$refs.alternativeDeliveryAddress.checked;
        },
        fetchCart : function() {
            return JSON.parse( localStorage.getItem( 'cart' ) );
        },
        fetchOrder : function() {
            var basket = {}
            basket.products = this.$store.getters.getBasket
            basket.customer = this.customer
            basket.deliveryAddress = this.deliveryAddress
            basket.billingAddress = this.billingAddress
            basket.showDeliveryAddress = this.showDeliveryAddress

            return basket
        },
        makePayment : function() {

            //if( this.checkOrder() )
            {
                let order = JSON.stringify( this.fetchOrder() );

                let formData = new FormData();

                formData.append( 'data', order );

                this.axios.post( '/php/store-order.php', formData ).then( response => {

                    console.log( response )
                    //formData = new FormData()
                    //formData.append( 'accountId', 'Big Blackdrops' )
                    //formData.append( 'jobId', response.data )

                    //this.axios.post( 'https://www.bigprintshop.co.uk/jsonFromRequestEndpoint', formData ).then( response => {
                    this.axios.get( 'https://www.bigprintshop.co.uk/jsonFromRequestEndpoint' ).then( response => {
                        
                        console.log( response )
                        //document.getElementById( 'endPointData' ).value = '{"MERCHANT_ID":"thinkbigprintbigtest","ACCOUNT":"BPS","ORDER_ID":"39554-1616072075","AMOUNT":"2710","CURRENCY":"GBP","TIMESTAMP":"20210318125435","AUTO_SETTLE_FLAG":"1","SHIPPING_CODE":"DY10 2BG","SHIPPING_CO":"826","HPP_SHIPPING_STREET1":"15-17 Coventry Street","HPP_SHIPPING_STREET2":"Kidderminster","HPP_SHIPPING_STREET3":"","HPP_SHIPPING_CITY":"","HPP_SHIPPING_POSTALCODE":"DY10 2BG","HPP_SHIPPING_COUNTRY":"826","BILLING_CODE":"DY10 2BG","BILLING_CO":"826","HPP_BILLING_STREET1":"15-17 Coventry Street","HPP_BILLING_STREET2":"Kidderminster","HPP_BILLING_STREET3":"","HPP_BILLING_CITY":"","HPP_BILLING_POSTALCODE":"DY10 2BG","HPP_BILLING_COUNTRY":"826","HPP_CUSTOMER_EMAIL":"luke@bigprintshop.co.uk","HPP_CUSTOMER_PHONENUMBER_MOBILE":"01562 865444","HPP_ADDRESS_MATCH_INDICATOR":"FALSE","HPP_VERSION":"2","SHA1HASH":"b8d8de2cc026cfffbaaa53277470cfb00ff723d7"}'
                        //document.getElementById( 'endPointData' ).click();
                        //document.getElementById( 'payNow' ).click();
                    } )

                } ), error => {

                    console.error( error )

                }


            }
            



        },



    },
    mounted : function(){

        var mainColour = this.mainColour

        /**
         * Apply custom colour to elements
         */

        var elements = document.getElementsByClassName('table')

        elements.forEach( function (element) {
            element.style.border = "1px solid " + mainColour
        } );

        elements = document.getElementsByClassName( 'title' )

        elements.forEach( function(element) {
            element.style.backgroundColor = mainColour
        } )
    }
}
</script>

<style scoped>
    .delivery-address{
        display: none;
    }

    .show{
        display: block;
    }

    .container{
        display: flex;
        flex-direction: column;
    }

    .table{
        padding: 0.5rem;
        border: 1px solid #4c8bf5;
        font-size: 0.8rem;
    }

    .title{
        font-size: 1.5rem;
        padding: 0.5rem 0;
        width: 100%;
        margin-top: 0.5rem;
        background-color: #4c8bf5;
        text-align: center;
        color: white;
    }

    input[type="text"]{
        padding: 0.5rem;
        margin-left: 1rem;
        margin-bottom: 0.25rem;
        width: 15rem;
        border: 1px solid black;
    }

    label{
        display:inline-block;
        width: 8rem;
        text-align: right;
    }

    .check-out-button{
        margin: 0.5rem
    }

    .check-out-button button{
        border: none;
        width: 100%;
        font-size: 1.5rem;
        padding: 1rem;
        background-color: #be2730;
        color: white;
    }

</style>